import { WDD } from '../core/wdd.js';

export function carousel() {
    WDD.sliders = Array.from(WDD.el.querySelectorAll('.bp-slider')).map((slider, i) => {
        slider = {
            el: slider,
            slides: slider.querySelectorAll('.bp-slider__item'),
        };

        // Remove old buttons before creating new ones
        slider.el.querySelectorAll('.bp-slider__slide-buttons').forEach(el => el.remove());

        // Create slide buttons
        const buttonsEl = document.createElement('div');
        buttonsEl.className = 'bp-slider__slide-buttons';

        const prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'bp-slider__slide-button bp-slider__slide-button--prev';

        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'bp-slider__slide-button bp-slider__slide-button--next';

        slider.buttons = {
            el:   slider.el.appendChild(buttonsEl),
            prev: buttonsEl.appendChild(prevBtn),
            next: buttonsEl.appendChild(nextBtn),
        };
        let isDown = false;
        let startX;
        let startY;
        let scrollLeft;
        let moved = false;
        let startTime;
        let lastX;
        const velocityThreshold = 0.5;
        const distanceThreshold = slider.wrapper?.offsetWidth * 0.25 || 0;

        // Move all slides into a wrapper
        slider.wrapper = document.createElement('div');
        slider.wrapper.classList.add('bp-slider__wrapper');
        slider.slides.forEach(slide => {
            slider.wrapper.appendChild(slide);
        });
        slider.el.appendChild(slider.wrapper);

        slider.handle = {
            inputStart: e => {
                isDown = true;
                moved = false;
                const pageY = e.type.startsWith('touch')
                    ? e.touches[0].pageY
                    : e.pageY;
                const pageX = e.type.startsWith('touch')
                    ? e.touches[0].pageX
                    : e.pageX;

                startTime = Date.now();
                lastX = pageX;
                startX = pageX - slider.wrapper.offsetLeft;
                startY = pageY - slider.wrapper.offsetTop;
                scrollLeft = slider.wrapper.scrollLeft;
                slider.el.classList.add('bp-slider--active');
            },
            inputMove: e => {
                if (!isDown) return;
                // ignore vertical swipe
                if (e.type.startsWith('touch')) {
                    const touch = e.touches[0];
                    const deltaX = Math.abs(touch.pageX - startX - slider.wrapper.offsetLeft);
                    const deltaY = Math.abs(touch.pageY - startY - slider.wrapper.offsetTop);

                    // allow vertical scrolling
                    if (deltaY > deltaX) return;
                }
                if (e.cancelable) e.preventDefault();

                const pageX = e.type.startsWith('touch')
                    ? e.touches[0].pageX
                    : e.pageX;
                const x = pageX - slider.wrapper.offsetLeft;
                const walk = (startX - x);

                if (Math.abs(walk) > 5) moved = true;
                slider.wrapper.scrollLeft = scrollLeft + walk;
                lastX = pageX;
            },
            inputEnd: e => {
                if (!isDown) return;
                isDown = false;
                slider.el.classList.remove('bp-slider--active');

                const deltaX = lastX - startX;
                const deltaTime = Date.now() - startTime;
                const velocity = deltaX / deltaTime;

                if (Math.abs(velocity) > velocityThreshold) {
                    // Fast swipe
                    if (velocity < 0) slider.handle.snap(1);
                    else slider.handle.snap(-1);
                    setTimeout(() => slider.handle.updateActive(), 300);
                }
                else if (Math.abs(deltaX) > distanceThreshold) {
                    // Slow but long enough drag
                    if (deltaX < 0) slider.handle.snap(1);
                    else slider.handle.snap(-1);
                    setTimeout(() => slider.handle.updateActive(), 300);
                }
                else {
                    slider.handle.snap();
                    slider.handle.updateActive();
                }
            },
            inputCancel: () => {
                isDown = false;
                slider.el.classList.remove('bp-slider--active');
            },
            mouseDrag: e => {
                e.preventDefault();
            },
            mouseEnter: e => {
                slider.el.classList.add('bp-slider--hover');
            },
            mouseLeave: e => {
                if (!isDown) return;
                slider.handle.snap();
                isDown = false;
                slider.el.classList.remove('bp-slider--hover');
                slider.el.classList.remove('bp-slider--active');
                slider.handle.updateActive();
            },
            mouseClick: e => {
                if (moved) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            menuClick: function(e, slider, data) {
                e.preventDefault();
                e.stopPropagation();
                const newScrollLeft = parseInt(data.el.dataset.index) * slider.handle.getSlideWidth();

                slider.wrapper.scrollTo({
                    left: newScrollLeft,
                    behavior: 'smooth'
                });

                slider.handle.updateActive(newScrollLeft);
            },
            prevNextClick: function(e, slider, name) {
                const itemWidth = slider.handle.getSlideWidth();
                const maxScrollLeft = slider.wrapper.scrollWidth - slider.wrapper.clientWidth;
                let newScrollLeft;
                
                if (name === "next") {
                    newScrollLeft = Math.min(slider.wrapper.scrollLeft + itemWidth, maxScrollLeft);
                } else if (name === "prev") {
                    newScrollLeft = Math.max(slider.wrapper.scrollLeft - itemWidth, 0);
                }

                slider.wrapper.scrollTo({
                    left: newScrollLeft,
                    behavior: 'smooth'
                });

                slider.handle.updateActive(newScrollLeft);
            },
            updateActive: function(scrollLeft) {
                // Finding the index of the active slide
                const scroll = scrollLeft ?? slider.wrapper.scrollLeft ?? 0;
                const foundIndex = Math.round(scroll / slider.handle.getSlideWidth());
                // Update active slide class
                const currentSlide = slider.slides[foundIndex];
                if (!currentSlide) return;
                slider.slides.forEach((slide, index) => slide.classList.toggle("bp-slider__slide--active", index === foundIndex));
            },
            getSlideWidth: function() {
                const gap = parseFloat(getComputedStyle(slider.wrapper).gap || 0);
                return slider.slides[0].offsetWidth + (isNaN(gap) ? 0 : gap);
            },
            snap: function(force) {
                // disable snapping if at the end
                const maxScrollLeft = slider.wrapper.scrollWidth - slider.wrapper.clientWidth;
                if (Math.abs(slider.wrapper.scrollLeft - maxScrollLeft) < 1) return;

                const itemWidth = slider.handle.getSlideWidth();
                const nearestSnap = Math.round(slider.wrapper.scrollLeft / itemWidth) * itemWidth + (force || 0) * itemWidth;

                slider.wrapper.scrollTo({
                    left: nearestSnap,
                    behavior: 'smooth'
                });
            }
        };

        // Add event listeners to the slider elements
        slider.el.querySelectorAll('.bp-slider__item').forEach(el => {
            el.addEventListener('dragstart', slider.handle.mouseDrag);
            el.addEventListener('click', e => {
                if (e.target.matches('.bp-slider__link, video')) {
                    slider.handle.mouseClick(e);
                }
            }, { capture: true });
        });
        slider.wrapper.addEventListener('mousedown',   slider.handle.inputStart);
        slider.wrapper.addEventListener('mouseup',     slider.handle.inputEnd);
        slider.wrapper.addEventListener('mousemove',   slider.handle.inputMove);
        slider.wrapper.addEventListener('mouseenter',  slider.handle.mouseEnter);
        slider.wrapper.addEventListener('mouseleave',  slider.handle.mouseLeave);
        slider.wrapper.addEventListener('touchstart',  slider.handle.inputStart, { passive: true });
        slider.wrapper.addEventListener('touchmove',   slider.handle.inputMove, { passive: false });
        slider.wrapper.addEventListener('touchend',    slider.handle.inputEnd);
        slider.wrapper.addEventListener('touchcancel', slider.handle.inputCancel);
        slider.buttons.prev.addEventListener('click', e => slider.handle.prevNextClick(null, slider, 'prev'));
        slider.buttons.next.addEventListener('click', e => slider.handle.prevNextClick(null, slider, 'next'));

        // Mark as active the slide that is currently in the viewport
        slider.handle.updateActive();
        return slider;
    });
}